// gimme: conversations-thread-view 06/30/2021 cfef6b9a8b3badc65b082ffd722b737fa8d16bdf
'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import UIList from 'UIComponents/list/UIList';
import { Popover } from 'foundations-components/transitional/components/Popover';
import SmallToggleButton from 'hubspot-prosemirror/draft-transplant/components/SmallToggleButton';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectFileDropdown = ({
  attachments,
  attachmentCountLimit,
  children,
  fileUploadCount,
  onOpenChange,
  open
}) => {
  const attachmentCountLimitReached = attachments.size + fileUploadCount >= attachmentCountLimit;
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    disabled: open,
    title: attachmentCountLimitReached ? I18n.text('composer-ui.prosemirror.plugins.attachments.attachment-limit-reached-label', {
      count: attachmentCountLimit
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.prosemirror.plugins.attachments.dropdown-label"
    }),
    children: /*#__PURE__*/_jsx(Popover, {
      closeOnOutsideClick: true,
      content:
      /*#__PURE__*/
      // eslint-disable-next-line hubspot-dev/no-private-classes
      _jsx(UIList, {
        className: "private-dropdown--list",
        children: children
      }),
      onOpenChange: onOpenChange,
      open: open,
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(SmallToggleButton, {
          active: open,
          icon: "attach",
          "data-test-id": "select-file-dropdown",
          onClick: onOpenChange
        })
      })
    })
  });
};
SelectFileDropdown.displayName = 'SelectFileDropdown';
SelectFileDropdown.propTypes = {
  attachmentCountLimit: PropTypes.number.isRequired,
  attachments: ImmutablePropTypes.listOf(PropTypes.object),
  children: PropTypes.node.isRequired,
  fileUploadCount: PropTypes.number.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
export default SelectFileDropdown;